import { type ReactNode } from 'react';
import type { AiCategory, AiConfidence, Creator } from '@/types';
import { Badge } from '@/components/ui/badge';

const CATEGORY_LABELS: Record<AiCategory, string> = {
  autor: 'Autor',
  bookgramer: 'Bookgramer',
  editorial: 'Editorial',
  libreria: 'Librería',
  biblioteca: 'Biblioteca',
  interesting_with_books: 'Con libros visibles',
  interesting_without_books: 'Sin libros pero interesante',
  rejected: 'Alertado',
  '': '—',
};

function confidenceVariant(c: AiConfidence): 'success' | 'warning' | 'default' {
  if (c === 'alta') return 'success';
  if (c === 'media') return 'warning';
  return 'default';
}

export function StatusBadge({ creator }: { creator: Creator }): ReactNode {
  const s = creator.ai_analysis_status;
  if (s === 'pending') return <Badge variant="default">Pendiente IA</Badge>;
  if (s === 'validated') return <Badge variant="success">IA validó</Badge>;
  if (s === 'rejected_by_ai') return <Badge variant="error">IA alertó</Badge>;
  return null;
}

export function CategoryBadge({
  category,
}: {
  category: AiCategory;
}): ReactNode {
  if (!category) return null;
  const variant = category === 'rejected' ? 'error' : 'info';
  return <Badge variant={variant}>{CATEGORY_LABELS[category]}</Badge>;
}

export function ConfidenceBadge({
  confidence,
}: {
  confidence: AiConfidence;
}): ReactNode {
  if (!confidence) return null;
  return (
    <Badge variant={confidenceVariant(confidence)}>
      Confianza {confidence}
    </Badge>
  );
}

export function AiBadgesRow({ creator }: { creator: Creator }): ReactNode {
  return (
    <div className="flex flex-wrap items-center gap-sm">
      <StatusBadge creator={creator} />
      <CategoryBadge category={creator.ai_category} />
      <ConfidenceBadge confidence={creator.ai_confidence} />
    </div>
  );
}
